import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { grabarPagoTransbank } from "../../services/motorService";
import useSession from "../../services/session";
import { CircularProgress, Box, Typography, Paper } from "@mui/material"; // Usando componentes de Material UI

const PaymentResult = ({setTransactionStatus}) => {
    const [searchParams] = useSearchParams();
    const [transactionDetails, setTransactionDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [savePaymentResult, setSavePaymentResult] = useState(null);
    const session = useSession();

    const commitTransaction = async (token) => {
        const backendUrl = `http://localhost:3001/api/webpay/commit/${token}`;

        try {
            const response = await axios.get(backendUrl);
            return response.data;
        } catch (error) {
            console.error("Error al confirmar la transacción:", error);
            throw error;
        }

        /*const url = `/rswebpaytransaction/api/webpay/v1.2/transactions/${token}`;
        const headers = {
            "Tbk-Api-Key-Id": "597055555532",
            "Tbk-Api-Key-Secret": "579B532A7440BB0C9079DED94D31EA1615BACEB56610332264630D42D0A36B1C",
            "Content-Type": "application/json",
        };

        try {
            await axios.get(url, { headers });

            const putResponse = await axios.put(url, {}, { headers });
            return putResponse.data;

        } catch (error) {
            console.error("Error al confirmar la transacción:", error);
            throw error;
        }*/
    };

    const savePayment = async (transactionDetails) => {



        const { amount, buy_order, card_detail, vci, transaction_date, status, payment_type_code } = transactionDetails;
        const paymentTypeMap = {
            VN: "Venta Normal",
            VC: "Venta en cuotas",
            SI: "3 cuotas sin interés",
            S2: "2 cuotas sin interés",
            S3: "3 cuotas sin interés",
            CI: "Cuotas comercio",
            VD: "Venta débito",
            VP: "Prepago",
        };

        const paymentTypeDescription = paymentTypeMap[payment_type_code] || "Desconocido";

        console.log("paymentTypeDescription", paymentTypeDescription);
        const data = {
            pagohotel: 1,
            Sesion: session,
            pagomoneda: 1,
            pagoimporte: amount,
            pagoorden: buy_order,
            pagotarjeta: card_detail.card_number,
            vci: vci,
            transaction_date: transaction_date,
            status: status,
            amount: amount,
            paymentTypeCode: payment_type_code,
            paymentTypeDescription: paymentTypeDescription,
        };

        console.log(data);


        /*try {
            const response = await grabarPagoTransbank(data);
            setSavePaymentResult("Resultado al grabar el pago: " + response.okpagoreserva);
        } catch (error) {
            setSavePaymentResult("Error al grabar el pago. Por favor, inténtelo nuevamente.");
        }*/
    };

    useEffect(() => {
        const token = searchParams.get("token_ws");
        if (!token) {
            setError("Token de transacción no proporcionado");
            setLoading(false);
            return;
        }

        const fetchTransactionDetails = async () => {
            try {
                const data = await commitTransaction(token);
                console.log("Token:", token);
                console.log("data", data);
                await savePayment(data);
                setTransactionDetails(data);
                setTransactionStatus(data);
            } catch (err) {
                setError("Error al confirmar la transacción. Verifica los detalles e inténtalo nuevamente.");
            } finally {
                setLoading(false);
            }
        };

        fetchTransactionDetails();
    }, [searchParams]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" p={3}>
                <CircularProgress />
                <Typography variant="h6" mt={2}>Cargando detalles de la transacción...</Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Box p={3} bgcolor="error.main" color="white" borderRadius={2}>
                <Typography variant="h6">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom>
                Resultado de la Transacción
            </Typography>
            {transactionDetails ? (
                <Paper elevation={3} sx={{ padding: 3, backgroundColor: "#f9f9f9" }}>
                    <Typography variant="h6" color="textPrimary"><strong>Estado:</strong> {transactionDetails.status}</Typography>
                    <Typography variant="body1" color="textSecondary"><strong>Monto:</strong> ${transactionDetails.amount}</Typography>
                    <Typography variant="body1" color="textSecondary"><strong>Orden de Compra:</strong> {transactionDetails.buy_order}</Typography>
                    <Typography variant="body1" color="textSecondary"><strong>Fecha:</strong> {transactionDetails.transaction_date}</Typography>
                    <Typography variant="body1" color="textSecondary"><strong>Tipo de Pago:</strong> {transactionDetails.payment_type_code}</Typography>
                    <Typography variant="body1" color="textSecondary"><strong>Últimos Dígitos de la Tarjeta:</strong> {transactionDetails.card_detail.card_number}</Typography>
                    {/*<Typography variant="body2" mt={2} color={savePaymentResult.includes("Error") ? "error.main" : "green"}>
                        {savePaymentResult}
                    </Typography>*/}
                </Paper>
            ) : (
                <Typography variant="body1" color="textSecondary">No se pudieron obtener los detalles de la transacción.</Typography>
            )}
        </Box>
    );
};

export default PaymentResult;
